import { useSelector, useDispatch } from 'react-redux'
import { setUser, initialState } from 'store/auth/userSlice'
import { apiSignIn, apiProfile } from 'services/AuthService'
import { onSignInSuccess, onSignOutSuccess } from 'store/auth/sessionSlice'
import appConfig from 'configs/app.config'
import { REDIRECT_URL_KEY } from 'constants/app.constant'
import { useNavigate } from 'react-router-dom'
import useQuery from './useQuery'

function useAuth() {
    const dispatch = useDispatch()

    const navigate = useNavigate()

    const query = useQuery()

    const { token, signedIn } = useSelector((state) => state.auth.session)

    const signIn = async (values) => {
        try {
            const loginResponse = await apiSignIn(values)
            const { accessToken } = loginResponse.data
            dispatch(onSignInSuccess(accessToken.token))
            const profileResponse = await apiProfile()

            const roleType = profileResponse.data.role?.type
            const authority =
                profileResponse.data.role?.permissions.map(
                    (permission) => permission.code
                ) || []

            dispatch(
                setUser({
                    name: profileResponse.data?.name,
                    role: roleType,
                    authority: authority,
                    title: profileResponse.data.role?.title,
                    email: profileResponse.data.email,
                    mobileNo: profileResponse.data.mobileNo,
                    myDepartments: profileResponse.data.myDepartments,
                })
            )
            const redirectUrl = query.get(REDIRECT_URL_KEY)
            navigate(
                redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath
            )
            return {
                status: 'success',
                message: '',
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const handleSignOut = () => {
        dispatch(onSignOutSuccess())
        dispatch(setUser(initialState))
        navigate(appConfig.unAuthenticatedEntryPath)
    }

    const signOut = async () => {
        // await apiSignOut()
        handleSignOut()
    }

    return {
        authenticated: token && signedIn,
        signIn,
        signOut,
    }
}

export default useAuth
